export default __webpack_public_path__ + "static/media/LEVEL15.4797a59e.png";